import qs from 'qs';
import cleanDeep from 'clean-deep';
import { IS_SNAP, SNAP_SHOT_LIMIT } from 'variables/main';

const InstitutionEndpoint = () => ({
  dataURL: 'education/institutions/programs',
  sourceName: 'educationInstitutions',
  autoLoad: true,
  getDataUrl: (url, { page, perPage, filters: { name, ...filtersRest }, sort, search }) => {
    const urlData = {
      filters: { ...filtersRest, search: name },
      sort
    };

    if (search) {
      urlData.search = search;
    }

    const offset = ((page || 1) - 1) * perPage;

    urlData.offset = offset;

    urlData.limit = IS_SNAP ? SNAP_SHOT_LIMIT : perPage;

    const queryString = qs.stringify(cleanDeep(urlData, { NaNValues: true }));

    return url + (queryString && '?' + queryString);
  },
  mapData: (payload) => {
    const { meta } = payload;
    const { limit, count, offset } = meta || {};

    return {
      data: payload,
      page: Math.ceil(Number(offset) / Number(limit)) + 1,
      perPage: limit,
      count
    };
  }
});

export default InstitutionEndpoint;
